import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FeatureFunction {
  id: number;
  title: string;
  icon: string;
  shortDescription: string;
  detailedDescription: string;
  imageData?: string; // Base64 encoded image
  imageContentType?: string;
  displayOrder: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateFeatureFunctionDTO {
  title: string;
  icon: string;
  shortDescription: string;
  detailedDescription: string;
  imageData?: string;
  imageContentType?: string;
  displayOrder?: number;
  isActive?: boolean;
}

export interface UpdateFeatureFunctionDTO {
  title?: string;
  icon?: string;
  shortDescription?: string;
  detailedDescription?: string;
  imageData?: string;
  imageContentType?: string;
  displayOrder?: number;
  isActive?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFunctionService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/featurefunctions`;

  /**
   * Abrufen aller aktiven Features (für Startseite)
   */
  getActiveFeatures(): Observable<FeatureFunction[]> {
    return this.http.get<FeatureFunction[]>(`${this.apiUrl}/active`);
  }

  /**
   * Abrufen aller Features inkl. inaktiver (Admin)
   */
  getAllFeatures(): Observable<FeatureFunction[]> {
    return this.http.get<FeatureFunction[]>(this.apiUrl);
  }

  /**
   * Abrufen eines spezifischen Features nach ID
   */
  getFeatureById(id: number): Observable<FeatureFunction> {
    return this.http.get<FeatureFunction>(`${this.apiUrl}/${id}`);
  }

  /**
   * Erstelle ein neues Feature
   */
  createFeature(dto: CreateFeatureFunctionDTO): Observable<FeatureFunction> {
    return this.http.post<FeatureFunction>(this.apiUrl, dto);
  }

  /**
   * Aktualisiere ein vorhandenes Feature
   */
  updateFeature(id: number, dto: UpdateFeatureFunctionDTO): Observable<FeatureFunction> {
    return this.http.put<FeatureFunction>(`${this.apiUrl}/${id}`, dto);
  }

  /**
   * Lösche ein Feature
   */
  deleteFeature(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
